import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

import { Button, PopupModal } from '@/shared/ui'

export const PopupModalCatalogPreview = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const update = () => setIsMobile(window.innerWidth < 768)
    update()
    window.addEventListener('resize', update)
    return () => window.removeEventListener('resize', update)
  }, [])

  return (
    <div className="flex flex-col items-start gap-3">
      <Button type="button" variant="secondary" onClick={() => setIsOpen(true)}>
        Show popup
      </Button>
      {isOpen
        ? createPortal(
            <PopupModal
              title="Изменить карту"
              showOverlay
              variant={isMobile ? 'mobile' : 'desktop'}
              showClose={!isMobile}
              showCloseText={isMobile}
              reserveBottomOffset={false}
              overlayWidth="100vw"
              overlayHeight="100vh"
              className="fixed inset-0 z-50"
              onClose={() => setIsOpen(false)}
            >
              Сейчас используется карта: <strong>2420****4320</strong>
              <br />
              Мы принимаем российские и зарубежные карты. Введите данные новой карты на следующем
              шаге.
            </PopupModal>,
            document.body
          )
        : null}
    </div>
  )
}
